import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {
@Input() size:any;
@Input() type:any;
className:string='pre-loader';
  constructor() { }

  ngOnInit(): void {
    if(!this.size){
      this.size='60'
    }
    if(this.type=='thin'){
     this.className='pre-loader-thin';
    }
  }

}
